const $$splitComponentImporter = () => import('/app/src/routes/dashboard/supervisor/index.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/supervisor/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface MonthStat {
  month: string;
  label: string;
  sessions: number;
}
interface StatusBreakdown {
  status: string;
  count: number;
}
interface TopEmployee {
  name: string;
  email: string | null;
  sessionCount: number;
}
interface RecentSession {
  id?: string;
  scheduledAt: string;
  status: string;
  durationMinutes: number;
  clientName: string;
}
interface CompanyOverview {
  name: string;
  planType: string;
  maxEmployees: number;
  employeeCount: number;
  activeEmployeeCount: number;
  sessionsThisMonth: number;
  analytics: {
    monthlyStats: MonthStat[];
    statusBreakdown: StatusBreakdown[];
    topEmployees: TopEmployee[];
    recentSessions: RecentSession[];
  };
}

/* ─── Stat Card ─── */